import { checkElementInView } from "../__utils/checkElementInView";

const animationSelectors = '.page-content > section:not(.no-animation), .page-hero > *, .blog-hero > *, .content-post > *, .fade-in, #page > section:not(.no-animation), .single-accommodation > section:not(.no-animation)';
const sections = document.querySelectorAll(animationSelectors);

const showSection = (e) => {
    e.classList.add('in-viewport');
};

const hideSection = (e) => {
};

const sectionsInView = () => {
    if (sections.length) {
        checkElementInView(animationSelectors, showSection, hideSection, {
            root: null,
            rootMargin: "0px 0px -20% 0px",
            threshold: [0],
        });
    }
};

export default sectionsInView;